// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__FH6k9","imageWrapper":"style_imageWrapper__99jRs"};